import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { StyledSidePanel } from './style';

class RightColumn extends PureComponent {
    state = { isExpanded: true }

    toggleColumn = () => {
        this.setState(prevState => ({
            isExpanded: !prevState.isExpanded
        }));
    }

    render() {
        const { isExpanded } = this.state;
        const {
            isExpandable,
            size,
            children
        } = this.props;

        return (
            <StyledSidePanel
                className={classNames(
                    'ui-side-panel',
                    { [size]: !isExpandable || isExpanded },
                    { xxxs: !isExpanded && isExpandable }
                )}
            >
                {children({ isExpanded, toggle: this.toggleColumn, isExpandable })}
            </StyledSidePanel>
        );
    }
}

RightColumn.propTypes = {
    children: PropTypes.any.isRequired,
    size: PropTypes.oneOf(['xxxs', 'xs', 'sm', 'md']),
    isExpandable: PropTypes.bool
};

RightColumn.defaultProps = {
    isExpandable: false,
    size: null
};

export default RightColumn;
